/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TPutReviewRequest, TPutReviewModel, IMappers, TPutReviewResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ICreateEditReviewResponseV3 } from '../../entities/web_entities/CreateEditReviewResponseV3';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createPutReviewModel(parameters: TPutReviewRequest): TPutReviewModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'reviews',
    pathApi: '/v3/put-review/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPutReviewOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPutReviewRequest;
}

export async function fetchPutReview<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPutReviewOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPutReviewResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPutReviewModel(parameters),
    config,
  )) as FetchResponse<TPutReviewResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateEditReviewResponseV3, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPutReviewResponse>;
}
